<mat-card appearance="outlined">
  <mat-card-subtitle [innerHtml]="data.text"></mat-card-subtitle>
  <mat-card-actions>
    <button mat-button *ngFor="let button of data.buttons" (click)="onExecuteButtonHandler(button, $event)">
      {{ button.text }}
    </button>
  </mat-card-actions>
</mat-card>
